module.exports = __webpack_public_path__ + "img/section4_pic2.0ab1a3c5.png";